import { render, staticRenderFns } from "./FormItemGroup.vue?vue&type=template&id=4b3967a0&scoped=true"
import script from "./FormItemGroup.vue?vue&type=script&lang=js"
export * from "./FormItemGroup.vue?vue&type=script&lang=js"
import style0 from "./FormItemGroup.vue?vue&type=style&index=0&id=4b3967a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3967a0",
  null
  
)

export default component.exports